import AppHeader from "@/components/AppHeader";
import AppSidebar from "@/components/AppSidebar";
import ContractProjectionsPanel from "@/components/ContractProjectionsPanel";
import { useAuth } from "@/context/AuthContext";

export default function ProjectionsPage() {
  const { user } = useAuth();
  return (
    <div className="app-shell" data-testid="projections-shell">
      <AppSidebar activeItem="Projections" />
      <div className="app-content">
        <AppHeader />
        <main className="dashboard-page ops-dashboard projections-page" data-testid="projections-page">
          <ContractProjectionsPanel canManage={user?.role === "system_administrator"} />
        </main>
      </div>
    </div>
  );
}
